import { TextBoxComponent } from "@progress/kendo-angular-inputs";

export function toggleTextboxPasswordVisibility(box : TextBoxComponent) {
    if(box.input.nativeElement.type == "password")
    {
      box.input.nativeElement.type = "text";
    }
    else if(box.input.nativeElement.type == "text"){
      box.input.nativeElement.type = "password";
    }
  }